import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';

import {environment} from '../../environments/environment';
import {Archive, ArchiveResponse, Filter, FilterItem, FilterQuery, FilterRequest} from './archive.model';

@Injectable({
  providedIn: 'root'
})
export class ArchiveService {

  public archive = new BehaviorSubject<Archive>(undefined);
  public filter = new BehaviorSubject<Filter>(undefined);
  public activeFilter = new BehaviorSubject<FilterQuery>(undefined);
  public isLoading = new BehaviorSubject<boolean>(false);

  public lastQuery = '';
  public currentPage = 1;

  constructor(private http: HttpClient) {
  }

  makeFilterQueryFromURLParams(params, filter): FilterQuery {
    let filterQuery: FilterQuery = {
        mood: null,
        flavor: null,
        location: null
    }

    if (params.mood) {
        let m = filter.moods.find(x => x.name == params.mood);
        filterQuery.mood = m;
    }
    if (params.flavor) {
        let m = filter.flavors.find(x => x.name == params.flavor);
        filterQuery.flavor = m;
    }
    if (params.location) {
        let m = filter.locations.find(x => x.name == params.location);
        filterQuery.location = m;
    }
    return filterQuery;
  }

  public init(params): void {
    let mflParamsPresent = (params.mood || params.flavor || params.location);
    this.isLoading.next(true);
    this.http.get(
      environment.cmsUrl + environment.routes.getArchive
    ).subscribe((data: ArchiveResponse) => {
      if (data.status) {

        if (!environment.production) {
          console.log({'Archive Data': data});
        }

        this.currentPage = 1;
        if (this.filter.value !== data.filter) {
          const sortedFilter = this.sortFilter(data.filter);
          this.filter.next(sortedFilter);
        }
        if (!mflParamsPresent) {
            let emptyFilterQuery: FilterQuery = {
                mood: null,
                flavor: null,
                location: null
            }
            this.activeFilter.next(emptyFilterQuery);
            this.archive.next(data.archive);
        }

      } else {
        console.log(data.message);
      }

      this.isLoading.next(false);
      if (mflParamsPresent) {
        this.search(this.makeFilterQueryFromURLParams(params, data.filter));
      }
    });
  }

  search(filterData: FilterQuery) {
    if (!this.isLoading.value) {
      const filter = {};

      this.activeFilter.next(filterData);

      for (const filterItem in filterData) {
        if (filterData.hasOwnProperty(filterItem)) {
          if (filterData[filterItem] !== null && filterData[filterItem] !== undefined) {
            filter[filterItem] = [filterData[filterItem].id];
          }
        }
      }

      this.lastQuery = Object.keys(filter).map(key => key + '=[' + filter[key] + ']').join('&');

      this.isLoading.next(true);
      this.http.get(
        environment.cmsUrl + environment.routes.getArchive + '?' + this.lastQuery
      ).subscribe((data: ArchiveResponse) => {
        if (data.status) {

          if (!environment.production) {
            console.log({'Archive Data': data});
          }

          this.currentPage = 1;
          this.archive.next(data.archive);
          if (this.filter.value !== data.filter) {
            const sortedFilter = this.sortFilter(data.filter);
            this.filter.next(sortedFilter);
          }

        } else {
          console.log(data.message);
        }

        this.isLoading.next(false);
      });
    }
  }

  loadNextPage(): void {
    if (!this.isLoading.value) {
      this.currentPage++;

      this.isLoading.next(true);
      this.http.get(
        environment.cmsUrl + environment.routes.getArchive + '?' + this.lastQuery + '&page=' + this.currentPage
      ).subscribe((data: ArchiveResponse) => {
        if (data.status) {
          if (!environment.production) {
            const title = ('Archive Page ' + this.currentPage + ' Data');
            const render = {};
            render[title] = data;
            console.log(render);
          }

          const archive = this.archive.getValue();

          archive.data = archive.data.concat(data.archive.data);

          this.archive.next(archive);
          const sortedFilter = this.sortFilter(data.filter);
          this.filter.next(sortedFilter);
        } else {
          console.log(data.message);
        }

        this.isLoading.next(false);
      });
    }
  }

  private sortFilter(filter: Filter): Filter {
    const sortFn = (a: FilterItem, b: FilterItem) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    };

    filter.moods.sort(sortFn);
    filter.flavors.sort(sortFn);
    filter.locations.sort(sortFn);

    return filter;
  }
}
